module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "aria-label": "unm footer",
      "id": "footer",
      "role": "contentinfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row unmfooter"
  }, [_c('div', {
    staticClass: "col-md-9 hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Academics"
    }
  }, [_c('h1', [_vm._v("Academics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://unmevents.unm.edu/site/academic"
    }
  }, [_vm._v("Academic Calendars")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://schedule.unm.edu/"
    }
  }, [_vm._v("Class Schedule")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/academics/"
    }
  }, [_vm._v("Colleges & Schools")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://catalog.unm.edu/"
    }
  }, [_vm._v("Course Catalog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://degrees.unm.edu/"
    }
  }, [_vm._v("Degrees & Certificates")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://grad.unm.edu/"
    }
  }, [_vm._v("Graduate Studies")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Campus Life"
    }
  }, [_c('h1', [_vm._v("Campus Life")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/arts/index.html"
    }
  }, [_vm._v("Arts & Entertainment")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.golobos.com"
    }
  }, [_vm._v("Athletics")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://diverse.unm.edu/"
    }
  }, [_vm._v("Diversity")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://recsvcs.unm.edu/"
    }
  }, [_vm._v("Recreational Services")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://sac.unm.edu"
    }
  }, [_vm._v("Student Activities")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://sub.unm.edu"
    }
  }, [_vm._v("Student Union")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Resources"
    }
  }, [_c('h1', [_vm._v("Resources")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://bookstore.unm.edu"
    }
  }, [_vm._v("Bookstore")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://computing.unm.edu"
    }
  }, [_vm._v("Computing")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://ce.unm.edu"
    }
  }, [_vm._v("Continuing Education")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://unmjobs.unm.edu"
    }
  }, [_vm._v("Employment")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/libraries/"
    }
  }, [_vm._v("Libraries")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://news.unm.edu"
    }
  }, [_vm._v("UNM Newsroom")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Information for..."
    }
  }, [_c('h1', [_vm._v("Information for…")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.unmalumni.com/"
    }
  }, [_vm._v("Alumni")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/facultyandstaff/"
    }
  }, [_vm._v("Faculty")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/parents-families/index.html"
    }
  }, [_vm._v("Parents & Families")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://hospitals.unm.edu"
    }
  }, [_vm._v("Patients")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://publicrecords.unm.edu/"
    }
  }, [_vm._v("Public Records - IPRA")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/facultyandstaff/"
    }
  }, [_vm._v("Staff")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://executivesearch.unm.edu/evp-for-health-sciences/index.html"
    }
  }, [_vm._v("EVP for Health Sciences\n                  Search")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 footer-buttons"
  }, [_c('a', {
    staticClass: "btn btn-default btn-lg btn-block",
    attrs: {
      "href": "https://www.unm.edu/apply"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "fa-check fa"
  }, [_vm._v(" ")]), _vm._v(" APPLY")]), _vm._v(" Now")]), _c('a', {
    staticClass: "btn btn-default btn-lg btn-block",
    attrs: {
      "href": "https://admissions.unm.edu/visit-us/"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "fa-calendar fa"
  }, [_vm._v(" ")]), _vm._v(" Visit")]), _vm._v(" UNM")]), _c('a', {
    staticClass: "btn btn-default btn-lg btn-block",
    attrs: {
      "href": "https://www.unmfund.org/"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "fa-gift fa"
  }, [_vm._v(" ")]), _vm._v(" Give")]), _vm._v(" to UNM")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu"
    }
  }, [_c('img', {
    attrs: {
      "alt": "The University of New Mexico",
      "src": "https://webcore.unm.edu/v2/images/unm-transparent-white.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("© The University of New Mexico "), _c('br'), _vm._v(" Albuquerque, NM 87131, (505) 277-0111 "), _c('br'), _vm._v(" New Mexico's\n          Flagship University")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/universityofnewmexico",
      "title": "UNM on Facebook"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-facebook fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on Facebook")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://instagram.com/uofnm",
      "title": "UNM on Instagram"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-instagram fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on Instagram")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/unm",
      "title": "UNM on Twitter"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-x-twitter fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on Twitter")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/unmlive",
      "title": "UNM on YouTube"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-youtube fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on YouTube")])])])]), _vm._v(" "), _c('p', [_vm._v("more at "), _c('a', {
    staticClass: "link-underline",
    attrs: {
      "href": "https://social.unm.edu",
      "title": "UNM Social Media Directory & Information"
    }
  }, [_vm._v("social.unm.edu")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline",
    attrs: {
      "id": "unm_footer_links"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://webmaster.unm.edu/support"
    }
  }, [_vm._v("Website Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/accessibility.html"
    }
  }, [_vm._v("Accessibility")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/legal.html"
    }
  }, [_vm._v("Legal")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/contactunm.html"
    }
  }, [_vm._v("Contact UNM")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/consumer-information/"
    }
  }, [_vm._v("Consumer Information")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://hed.state.nm.us/resources-for-schools/public_schools/tableau-charts-and-tables"
    }
  }, [_vm._v("New\n              Mexico Higher Education Dashboard")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://finaid.unm.edu/cares-act.html"
    }
  }, [_vm._v("CARES Act")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c4530a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unm_footer.vue
// module id = 1130
// module chunks = 1